<template>
  <v-container>
    <div id="headersTime">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <template>
          <v-container
            v-if="enableRadioGroup"
            id="radioGroupBarChart"
          >
            <v-radio-group
              v-model="selectedFatVolume"
              row
            >
              <v-radio
                label="Dados Faturamento"
                value="tableFaturamento"
              />
              <v-radio
                label="Dados Volume"
                value="tableVolume"
              />
            </v-radio-group>
          </v-container>
        </template>
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacao"
                  style="text-align: center;"
                />
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Estrutura Organizacional
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  {{ textoFaturamento }}
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  {{ textoFatAnterior }}
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  {{ textoVariacaoMensal }}
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  {{ textoFaTAnoAnterior }}
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  {{ textoVariacaoAnual }}
                </th>
              </tr>
            </thead>
            <tbody
              v-for="(item, index) in (enableFaturamento ? evolucaoVendasSupervisor : evolucaoVolumeSupervisor)"
              :key="item.id"
            >
              <!-- Linha principal -->
              <tr>
                <td style="text-align: center;">
                  <button @click="toggleExpand(index)">
                    {{ expanded.includes(index) ? '▲' : '▼' }}
                  </button>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento_mes_anterior }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  <v-chip
                    :color="getColor(item.variacao_mensal)"
                    dark
                  >
                    {{ item.variacao_mensal }}
                  </v-chip>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento_ano_anterior }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  <v-chip
                    :color="getColor(item.variacao_anual)"
                    dark
                  >
                    {{ item.variacao_anual }}
                  </v-chip>
                </td>
              </tr>
              <!-- Linha expandida -->
              <tr
                v-if="expanded.includes(index)"
                :key="'expanded-' + item.id"
              >
                <td colspan="7">
                  <div style="overflow-x: auto;">
                    <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                      <thead>
                        <tr>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            Estrutura Organizacional
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            {{ textoFaturamento }}
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            {{ textoFatAnterior }}
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            {{ textoVariacaoMensal }}
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            {{ textoFaTAnoAnterior }}
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                          >
                            {{ textoVariacaoAnual }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(sub, idx) in item.evolucaoVendasVendedores"
                          :key="idx"
                        >
                          <td
                            id="dadoMovimentacao"
                            style="text-align: left;"
                          >
                            {{ sub.nome }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ sub.faturamento }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ sub.faturamento_mes_anterior }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            <v-chip
                              :color="getColor(sub.variacao_mensal)"
                              dark
                            >
                              {{ sub.variacao_mensal }}
                            </v-chip>
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ sub.faturamento_ano_anterior }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            <v-chip
                              :color="getColor(sub.variacao_anual)"
                              dark
                            >
                              {{ sub.variacao_anual }}
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Time from '../../../../../services/time4'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamentoVendasTime',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      expanded: [],
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      segmento: [],
      rede: [],
      categoria: [],
      promotor: [],
      area: [],
      classificacao: [],
      linhaProducao: [],
      headersEvolucaoVendas: [
        { text: 'Estrutura Organizacional', value: 'nome', width: '30%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Fat. Mês Anterior', value: 'faturamento_mes_anterior', align: 'right', class: 'black--text title' },
        { text: 'Variação de Fat. Mensal', value: 'variacao_mensal', align: 'right', class: 'black--text title' },
        { text: 'Fat. Mês do Ano Anterior', value: 'faturamento_ano_anterior', align: 'right', class: 'black--text title' },
        { text: 'Variação de Fat. Anual', value: 'variacao_anual', align: 'right', class: 'black--text title' },
      ],
      evolucaoVendasSupervisor: [],
      evolucaoVolumeSupervisor: [],
      expandir: false,
      textoFaturamento: 'Faturamento',
      textoFatAnterior: 'Fat. Mês Anterior',
      textoVariacaoMensal: 'Variação de Fat. Mensal',
      textoFaTAnoAnterior: 'Fat. Mês do Ano Anterior',
      textoVariacaoAnual: 'Variação de Fat. Anual',
      selectedFatVolume: 'tableFaturamento',
      enableRadioGroup: false,
      enableFaturamento: true,
    }),

    watch: {
      selectedFatVolume (newVal) {
        this.renderTable(newVal)
      },
    },

    created () {
      eventEmit.$on('update-time', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-time', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, segmento, rede, categoria, promotor, area, classificacao, linhaProducao) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor
        this.area = area
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao

        this.showEvolucaoVendas()
      },

      async showEvolucaoVendas () {
        this.loading = true

        this.evolucaoVendasSupervisor = []
        this.evolucaoVolumeSupervisor = []
        this.expanded = []

        this.selectedFatVolume = 'tableFaturamento'

        this.textoFaturamento = 'Faturamento'
        this.textoFatAnterior = 'Fat. Mês Anterior'
        this.textoVariacaoMensal = 'Variação de Fat. Mensal'
        this.textoFaTAnoAnterior = 'Fat. Mês do Ano Anterior'
        this.textoVariacaoAnual = 'Variação de Fat. Anual'

        await Time.showDadosTime4Vendas(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.segmento, this.rede, this.categoria, this.promotor, this.area, this.classificacao, this.linhaProducao).then(resposta => {
          if (resposta.data.status) {
            this.montarDadosFaturamento(resposta.data.faturamentoSupervisor)

            this.enableFaturamento = true

            this.montarDadosVolume(resposta.data.volumeSupervisor)
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.evolucaoVendasSupervisor = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.enableRadioGroup = true
        })
      },

      montarDadosFaturamento (dados) {
        const setPerson = new Set()

        const filterSupervisores = dados.filter((person) => {
          const duplicatedPerson = setPerson.has(person.nome_supervisor)
          setPerson.add(person.nome_supervisor)
          return !duplicatedPerson
        })

        this.evolucaoVendasSupervisor = filterSupervisores.map((item) => {
          var listaFaturamentoSupervisor = ({
            nome: item.nome_supervisor,
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            faturamento_mes_anterior: parseFloat(item.faturamento_mes_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            variacao_mensal: item.variacao_mensal + '%',
            faturamento_ano_anterior: parseFloat(item.faturamento_ano_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            variacao_anual: item.variacao_anual + '%',
            cod_supervisor: item.cod_supervisor,
            icone: item.icone,
            expandir: item.expandir,
            evolucaoVendasVendedores: this.orderVendedores(item.evolucaoVendasVendedores),
          })

          return listaFaturamentoSupervisor
        })
      },

      orderVendedores (value) {
        const setPerson = new Set()

        const filterVendedores = value.filter((person) => {
          const duplicatedPerson = setPerson.has(person.nome)
          setPerson.add(person.nome)
          return !duplicatedPerson
        })

        const vendedores = filterVendedores.map((item) => {
          var listaFaturamentoVendedores = ({
            nome: item.nome,
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            faturamento_mes_anterior: parseFloat(item.faturamento_mes_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            variacao_mensal: item.variacao_mensal + '%',
            faturamento_ano_anterior: parseFloat(item.faturamento_ano_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            variacao_anual: item.variacao_anual + '%',
          })

          return listaFaturamentoVendedores
        })

        return vendedores
      },

      montarDadosVolume (dados) {
        const setPerson = new Set()

        const filterSupervisores = dados.filter((person) => {
          const duplicatedPerson = setPerson.has(person.nome_supervisor)
          setPerson.add(person.nome_supervisor)
          return !duplicatedPerson
        })

        this.evolucaoVolumeSupervisor = filterSupervisores.map((item) => {
          var listaFaturamentoSupervisor = ({
            nome: item.nome_supervisor,
            faturamento: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            faturamento_mes_anterior: parseFloat(item.volume_mes_anterior).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            variacao_mensal: item.variacao_mensal + '%',
            faturamento_ano_anterior: parseFloat(item.volume_ano_anterior).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            variacao_anual: item.variacao_anual + '%',
            cod_supervisor: item.cod_supervisor,
            icone: item.icone,
            expandir: item.expandir,
            evolucaoVendasVendedores: this.orderVendedoresVolume(item.evolucaoVendasVendedores),
          })

          return listaFaturamentoSupervisor
        })
      },

      orderVendedoresVolume (value) {
        const setPerson = new Set()

        const filterVendedores = value.filter((person) => {
          const duplicatedPerson = setPerson.has(person.nome)
          setPerson.add(person.nome)
          return !duplicatedPerson
        })

        const vendedores = filterVendedores.map((item) => {
          var listaFaturamentoVendedores = ({
            nome: item.nome,
            faturamento: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            faturamento_mes_anterior: parseFloat(item.volume_mes_anterior).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            variacao_mensal: item.variacao_mensal + '%',
            faturamento_ano_anterior: parseFloat(item.volume_ano_anterior).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            variacao_anual: item.variacao_anual + '%',
          })

          return listaFaturamentoVendedores
        })

        return vendedores
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      expandedVendedores (value) {
        if (value.icone === 'mdi-plus') {
          value.expandir = true
          value.icone = 'mdi-minus'
          this.evolucaoVendasVendedores = value.evolucaoVendasVendedores
          this.expandir = true
        } else {
          this.expandir = false
          value.icone = 'mdi-plus'
          value.expandir = false
          this.evolucaoVendasVendedores = []
        }
      },

      getColor (value) {
        if (value < '0%') {
          return 'red'
        } else {
          return 'green'
        }
      },

      renderTable (tipo) {
        setTimeout(() => {
          if (tipo === 'tableFaturamento') {
            this.enableFaturamento = true

            this.textoFaturamento = 'Faturamento'
            this.textoFatAnterior = 'Fat. Mês Anterior'
            this.textoVariacaoMensal = 'Variação de Fat. Mensal'
            this.textoFaTAnoAnterior = 'Fat. Mês do Ano Anterior'
            this.textoVariacaoAnual = 'Variação de Fat. Anual'
          } else if (tipo === 'tableVolume') {
            this.enableFaturamento = false

            this.textoFaturamento = 'Volume (L)'
            this.textoFatAnterior = 'Volume Mês Anterior (L)'
            this.textoVariacaoMensal = 'Variação Volume Mensal'
            this.textoFaTAnoAnterior = 'Volume Mês Ano Anterior (L)'
            this.textoVariacaoAnual = 'Variação Volume Anual'
          }
        }, 500)
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

  #dadoMovimentacao {
    font-size: 12px;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersTime {
      font-size: 9px;
      width: 100% !important;
    }

    #dadoMovimentacao {
      font-size: 9px;
    }

    .tr-max {
      display:none;
    }
    .tr-min {
      display:table;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersTime {
      font-size: 9px;
      max-width: 100%;
    }
  }
</style>

<style lang="sass">
  #headersTime
    font-size: 9px

  .tr-min
    display:none

  #radioGroupBarChart
    margin: -4rem 0 0 0rem
</style>
